import {useEffect, useRef} from 'react';
import { createPortal } from "react-dom";

export const usePortal = () => {
	const portalElement = document.getElementById("portal-items");
	const elementRef = useRef(null);
	if (!elementRef.current) elementRef.current = document.createElement('div');

	useEffect(() => {
		if (!portalElement || !elementRef.current) return undefined;
		portalElement.appendChild(elementRef.current);

		return () => {
			if (portalElement.contains(elementRef.current)) {
				portalElement.removeChild(elementRef.current);
			}
		};
	}, [portalElement]);

	return {
		render: children => {
			return elementRef.current ? createPortal(children, elementRef.current) : null;
		},
	};
};
